// extracted by mini-css-extract-plugin
export default {"icon":"QuestionIcon_icon__dJI23"};